
import { useLanguage } from "@/contexts/LanguageContext";

const HomeFooter = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#1A237E] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="text-2xl font-bold mb-4">FRANK</div>
          <p className="text-[#E6EEF5]">
            {t('footer.tagline')}
          </p>
        </div>
        <div className="border-t border-[#673AB7] mt-8 pt-8 text-center text-[#E6EEF5]">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
